import { GetterTree } from 'vuex';
import PnpToolState from './types';
import PnpItem from '../../../models/PnpItem';

export const pnpToolGetters: GetterTree<PnpToolState, never> = {
  // Tool Visibility
  getPnpToolState(state): Map<string, boolean> {
    return state.toolMap;
  },
  // Buttons
  getPnpItemArray(state): Array<PnpItem> {
    return state.pnpItemArray;
  },
};
